<template>
    <div id="app">
        <router-view ref="worknode" />
    </div>
</template>

<script>
import mqtt from 'mqtt'
import base from '@/utils/base'
import { getFormDetail } from '@/api/design'
import scanhelper from '@/utils/scanhelper'
import company from './json/company.json'
export default {
    name: 'App',
    data() {
        return {
            client: null,
            listenmqtttimeoutid: 0
        }
    },
    mounted() {
        const that = this
        this.$store.dispatch('screen/modifyScreen')
        window.onresize = () => {
            that.$store.dispatch('screen/modifyScreen')
        }
        scanhelper.scan(this.onscan)
        if (base.isWeixinBrowser().isWeixin === true) {

        }
    },
    methods: {
        async listenmqtt() {
            console.log('listenmqtt')
            try {
                const clientId = this.$store.getters.username
                // 获取当前的地址
                let mqtturl = `ws://${window.location.hostname}:18888`

                if (company.customers && company.customers.length > 1) {
                    const workcustomer = localStorage.getItem('workcustomer')
                    const customer = company.customers.find(c => c.name === workcustomer)
                    if (customer && customer.mqtturl) {
                        mqtturl = customer.mqtturl
                    }
                }
                if (this.client === null || !this.client.connected) {
                    if (this.client) {
                        this.client.on('close', () => {})
                        this.client.end()
                    }
                    this.client = mqtt.connect(mqtturl, {
                        clientId: clientId,
                        username: 'wxl',
                        password: 'wxl1236987'
                    })
                    // 订阅消息
                    this.client.on('connect', this.onconnectmqtt)
                    // 处理断开
                    this.client.on('close', this.onclosemqtt)
                    // 处理收到的消息
                    this.client.on('message', this.onmqttmessage)
                }
            } catch (e) {
                console.log(e)
            }
        },
        onconnectmqtt() {
            this.client.subscribe(`/notify/` + this.$store.getters.username)
            this.client.subscribe(`/Board/DataSource`)
        },
        onclosemqtt() {
            console.log('onclosemqtt')
            this.client.on('close', () => {})
            this.client.end()
            clearTimeout(this.listenmqtttimeoutid)
            this.onclosemqtttimeoutid = setTimeout(this.listenmqtt, 30 * 1000)
        },
        onmqttmessage(topic, message) {
            const that = this
            const data = JSON.parse(message.toString())
            if (topic === `/Board/DataSource`) {
                this.$bus.$emit('onloaddata', data)
                return
            }
            if (topic === `/notify/` + this.$store.getters.username) {
                this.$notify({
                    position: 'bottom-right',
                    type: 'success',
                    title: data.title,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: `<div class="notify-content">${data.message}</div>`,
                    onClick: async function() {
                        try {
                            console.log('data', data)
                            const forminfo = (await getFormDetail(data.toformid)).data
                            console.log('forminfo', forminfo)
                            that.$store.commit('design/setSelectForm', forminfo)
                            that.$router.push({ name: 'OABill', query: { billId: data.tobillid }})
                        } catch (e) {
                            this.$message.error(e.message)
                        }
                    }
                })
            }
        },
        onscan(barcode) {
            if (this.$refs.worknode) {
                console.log(this.$refs.worknode)
                this.$refs.worknode.onscan(barcode)
            }
        }
    },
    watch: {
        '$store.getters.username'() {
            this.listenmqtt()
        }
    }
}
</script>
<style lang="less">
    .el-notification__title{
        user-select: none;
    }
    .notify-content{
        cursor: pointer;
        user-select: none;
        &:hover{
            text-decoration: underline;
        }
    }
</style>
